import Separator from "@/v2-ui/separator"
import StatusKpisSkeleton from "@/v2-status-client/status/skeleton/StatusKpisSkeleton"
import StatusPlatformNavSkeleton from "@/v2-status-client/status/skeleton/StatusPlatformNavSkeleton"
import StatusServicesSkeleton from "@/v2-status-client/status/skeleton/StatusServicesSkeleton"
// import StatusProviderListSkeleton from "@/v2-status-client/status/skeleton/StatusProviderListSkeleton"
import StatusIncidentListSkeleton from "@/v2-status-client/status/skeleton/StatusIncidentListSkeleton"

// Whole-page skeleton rendered for the very first load before any
// status payload has arrived. Mirrors the live layout 1:1 so that
// when data lands the visual lengths stay roughly the same and
// the page doesn't jump. Each subsection's skeleton lives next to
// its real component (`StatusKpisSkeleton` next to `StatusKpis`,
// etc.) -- the page skeleton is purely the composition glue.
//
// The header and footer are intentionally NOT part of the
// skeleton: both are static (brand strip, brand nav) and render
// instantly without needing data, so we let `StatusPage` slot the
// real ones around the skeleton instead of cloning placeholders.
function StatusPageSkeleton() {
  return (
    <div
      className="flex flex-col gap-6"
      role="status"
      aria-live="polite"
      aria-label="Loading service status"
    >
      <StatusKpisSkeleton />
      <StatusPlatformNavSkeleton />
      <StatusServicesSkeleton />
      <Separator />
      {/* <StatusProviderListSkeleton /> */}
      <StatusIncidentListSkeleton />
    </div>
  )
}

export default StatusPageSkeleton
